import { createOpenStore } from "stores/createOpenStore";

export interface LinkedColumnsOpen {
  tableId: string;
  columnId: string;
  /** Above a bar slot; beside the details pane without one. */
  anchor?: HTMLElement;
}

export const useLinkedColumnsStore = createOpenStore<LinkedColumnsOpen>();

/** A column's link badge presses its list open and closed. */
export function toggleLinkedColumns(tableId: string, columnId: string): void {
  const { open, show, close } = useLinkedColumnsStore.getState();
  if (open?.tableId === tableId && open.columnId === columnId) close();
  else show({ tableId, columnId });
}
